// constants.js — Merkezi sabitler
// Bu dosyayı değiştirerek tüm frontend'deki lig listesini güncelleyebilirsiniz.

export const ALL_LEAGUES = ["Süper Lig", "TFF 1. Lig", "Premier League", "Championship", "La Liga", "Segunda Division", "Bundesliga", "2. Bundesliga", "Serie A", "Serie B", "Ligue 1", "Ligue 2", "Eredivisie", "Pro League", "Primeira Liga", "Champions League", "World Cup", "Scottish Premiership", "Austrian Bundesliga", "Super League Greece", "Russian Premier League", "Superliga", "Allsvenskan", "Eliteserien", "Swiss Super League"];

export const WEEK_START_DAY = 2; // 0=Pazar, 1=Pazartesi, 2=Salı

export function getWeekRange() {
  const d = new Date(), day = d.getDay();
  const diff = (day - WEEK_START_DAY + 7) % 7;
  const start = new Date(d); start.setDate(d.getDate() - diff);
  const end   = new Date(start); end.setDate(start.getDate() + 6);
  return {
    start: start.toISOString().slice(0, 10),
    end:   end.toISOString().slice(0, 10),
  };
}
